var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckboxOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "check_box_outline_blank",
    clipPath: "url(#clip0_2837_6534)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.75 5V19H5.75V5H19.75ZM19.75 3H5.75C4.65 3 3.75 3.9 3.75 5V19C3.75 20.1 4.65 21 5.75 21H19.75C20.85 21 21.75 20.1 21.75 19V5C21.75 3.9 20.85 3 19.75 3Z",
    fill: "#8F8F8F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2837_6534"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.75)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxOutlined);
export default __webpack_public_path__ + "static/media/checkbox-outlined.6403545b71606fbb813d969902b5a625.svg";
export { ForwardRef as ReactComponent };